define('v3/Common/Helpers/Loader/Loader.Extender',[
	'knockout'
], function (ko) {
	var debug = false;
	var log = function (msg) {
		if (debug) {
			console.log(msg);
		}
	};

	ko.extenders.loading = function (target) {
		var clearingData = false;
		target.isLoading = ko.observable(true);

		target.clearData = function () {
			clearingData = true;
			target([]);
			log('array reset');
			target.isLoading(true);
			log('enabling loader');
			clearingData = false;
		};

		target.subscribe(function () {
			if (!clearingData) {
				log('data received');
				target.isLoading(false);
				log('disabling loader');
			}
		});

		return target;
	};
});
